import { render, staticRenderFns } from "./InboxIconWithName.vue?vue&type=template&id=75477ebc&scoped=true&"
import script from "./InboxIconWithName.vue?vue&type=script&lang=js&"
export * from "./InboxIconWithName.vue?vue&type=script&lang=js&"
import style0 from "./InboxIconWithName.vue?vue&type=style&index=0&id=75477ebc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75477ebc",
  null
  
)

export default component.exports